import { createReducer, on } from '@ngrx/store';
import { recentInputInitialState, RecentInputState } from '@store/states/recent-input.state';
import { recentInputActions } from '@store/actions/recent-input.actions';

export const recentInputReducer = createReducer(
  recentInputInitialState,
  on(recentInputActions.addRecentInput, (state, data): RecentInputState => {
    const key = data.key;
    const recent = data.value;
    const array = state.all[key];
    let finalArray;
    if (array == null) {
      finalArray = [recent];
    } else {
      finalArray = [recent, ...array];
    }
    const lastIndex = finalArray.lastIndexOf(recent);
    if (lastIndex !== 0) {
      finalArray.splice(lastIndex, 1);
    }
    while (finalArray.length > 4) {
      finalArray.pop();
    }
    return {
      all: {
        ...state.all,
        [key]: finalArray,
      },
    };
  }),
  on(recentInputActions.removeRecentInput, (state, data): RecentInputState => {
    const key = data.key;
    const recent = data.value;
    const array = state.all[key];
    if (array == null) {
      return state;
    } else {
      const lastIndex = array.lastIndexOf(recent);
      if (lastIndex < 0) {
        return state;
      }
      const finalArray = [...array];
      finalArray.splice(lastIndex, 1);
      return {
        all: {
          ...state.all,
          [key]: finalArray,
        },
      };
    }
  })
);
